import styled from 'styled-components';
import Link from 'next/link';
// styles
import { mediaQuery } from 'cds/styles';

/** 헤더 로고 */
const Logo = () => {
  return (
    <Link href={`${process.env.NEXT_PUBLIC_DEFAULT_HOST}`} passHref>
      <HomeLink className="noselect">
        <Image
          src={`${process.env.NEXT_PUBLIC_ASSET_PREFIX}/img/class/classu_logo_white.png`}
          alt="logo"
        />
        <MobileImage
          src={`${process.env.NEXT_PUBLIC_ASSET_PREFIX}/img/class/classtok_symbol_w.png`}
          alt="logo"
        />
      </HomeLink>
    </Link>
  );
};

const HomeLink = styled.a`
  flex-shrink: 0;
  display: none;

  ${mediaQuery.large} {
    display: block;
  }
`;

const Image = styled.img`
  display: none;
  flex-basis: 130px;
  width: 130px;
  height: auto;
  max-width: none;

  ${mediaQuery.large} {
    display: block;
  }
`;

const MobileImage = styled.img`
  display: block;
  width: 30px;

  ${mediaQuery.large} {
    display: none;
  }
`;

export default Logo;
